// const ApiUrl = 'http://localhost:5000/backend/api'
const ApiUrl = process.env.REACT_APP_API_URL
// const BaseUrl = 'http://localhost:5000'
const BaseUrl = process.env.REACT_APP_BASE_URL
// const ApiUrl = process.env.API_URL || 'http://localhost:5000/api';

export { ApiUrl, BaseUrl };